import "//shopakaso.com/cdn/shop/t/25/assets/swiper@11.min.js?v=104684603862494721831780911930"
import "//shopakaso.com/cdn/shop/t/25/assets/jquery.js?v=147293088974801289311780911872"

// 入口函数，在页面加载完成后执行
function main() {
    Alpine.data('storeAccessoriespc', function () {
        const el = $(this);
        return {
            localName: window.Shopify.locale,
            init() {}, // end init

        }
    })
}
document.addEventListener('alpine:init', main)